<template lang="pug">
  div(:class="this.payload.fields.name.replace(/\s+/g, '-').toLowerCase()+' section-container container-'+this._uid")
    ul.collection.grid
      li.item(v-for="(d, i) in this.collectionItems" :class="!d.raw.fields.active && 'inactive'")
        a(v-if="d.directRef" :href="d.directRef")
          h4.title
            vue-markdown(:source='d.title')
          vue-markdown(:source='d.desc' class="desc")
        router-link(v-if="!d.directRef" :to="{ path: d.slug ? '/' + d.slug : '/' + d.type.toLowerCase() + '/' + d.id}" :key="'collection-item-' + i")
          h4.title
            vue-markdown(:source='d.title')
          vue-markdown(:source='d.desc' class="desc")
    router-link.section-link.button.minimal(v-show="this.link" :to="{ path: this.link }") {{ 'All ' + this.payload.fields.name.toLowerCase() }}
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/sectionBase.js'
import anime from 'animejs'

// Storing animation target elements
const animTargets = {
  container: '#container'
}

// TODO: create parseCollection function for normalizing collection data (to account for it not actually being a collection but just a raw list of entries) for all template components like this one and contentSlider etc

// component instance
var collectionGrid = Vue.component('collection-grid', {
  name: 'collectionGrid',
  mixins: [sectionBase],
  props: [],
  data: function () {
    return {
    }
  },
  watch: {
  },
  methods: {
  },
  computed: {
    collectionItems () {
      // @products - TODO: product routes should be created per (retrieved) type
      let items = []
      this.payload.fields.content.forEach((d) => {
        items.push({title: d.fields.title, desc: d.fields.description, type: d.fields.type, category: d.fields.category, price: d.fields.price, id: d.sys.id, directRef: d.fields.directRef, raw: d})
      })
      return items
    },
    actions () {
      // let component = this

      return {
        SET: () => {
          return anime({
            targets: animTargets.container + this._uid,
            easing: 'easeInOutQuad',
            opacity: [
              { value: '1' }
            ],
            translateX: [
              { value: 0 }
            ],
            translateY: [
              { value: 0 }
            ],
            borderColor: [
              { value: '#F0F0F0' }
            ],
            boxShadow: [
              { value: '0px 0px 10px rgba(211,211,211,1)' }
            ],
            duration: 200,
            begin: function (e) {
              console.log('set')
            },
            complete: function () {
            }
          })
        }
      }
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default collectionGrid
</script>

<style scoped>
  .section-container{
    margin-top: 3rem;
  }
  li > a {
    display: block;
    padding: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/sections/collectionGrid.vue